module.exports = __webpack_public_path__ + "static/Gotham-Black-5f6e0ec0a57cdc82bf24b4c1cdab81c0.woff";